import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=871d3268&scoped=true"
import script from "./Forms.vue?vue&type=script&lang=js"
export * from "./Forms.vue?vue&type=script&lang=js"
import style0 from "./Forms.vue?vue&type=style&index=0&id=871d3268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871d3268",
  null
  
)

export default component.exports